"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var escape_element_1 = require("./escape-element");
/**
 * Represents an XML text value.
 */
var XmlText = /** @class */ (function () {
    function XmlText(value) {
        this.value = value;
    }
    XmlText.prototype.toString = function () {
        return escape_element_1.escapeElement("" + this.value);
    };
    return XmlText;
}());
exports.XmlText = XmlText;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiWG1sVGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9YbWxUZXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsbURBQWlEO0FBRWpEOztHQUVHO0FBQ0g7SUFDRSxpQkFBb0IsS0FBYTtRQUFiLFVBQUssR0FBTCxLQUFLLENBQVE7SUFBRyxDQUFDO0lBRXJDLDBCQUFRLEdBQVI7UUFDRSxPQUFPLDhCQUFhLENBQUMsRUFBRSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUN4QyxDQUFDO0lBQ0gsY0FBQztBQUFELENBQUMsQUFORCxJQU1DO0FBTlksMEJBQU8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBlc2NhcGVFbGVtZW50IH0gZnJvbSBcIi4vZXNjYXBlLWVsZW1lbnRcIjtcbmltcG9ydCB7IFN0cmluZ2FibGUgfSBmcm9tIFwiLi9zdHJpbmdhYmxlXCI7XG4vKipcbiAqIFJlcHJlc2VudHMgYW4gWE1MIHRleHQgdmFsdWUuXG4gKi9cbmV4cG9ydCBjbGFzcyBYbWxUZXh0IGltcGxlbWVudHMgU3RyaW5nYWJsZSB7XG4gIGNvbnN0cnVjdG9yKHByaXZhdGUgdmFsdWU6IHN0cmluZykge31cblxuICB0b1N0cmluZygpOiBzdHJpbmcge1xuICAgIHJldHVybiBlc2NhcGVFbGVtZW50KFwiXCIgKyB0aGlzLnZhbHVlKTtcbiAgfVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/xml-builder/build/XmlText.js
// module id = 8JE8
// module chunks = 0